var DbDoc, NMA_OUTCOME_PREFIX, autoCalculateEffectClassification, autoCalculateEffectInterpretation, convertListToOrderedMap, gdtOutcomeDataToNmaOutcomeData, gdtOutcomeTypeToNmaVizOutcomeType, nmaOutcomeDataToGdtData, nmaOutcomeDocShape, _ref;

DbDoc = require('lib/db_docs/db_doc');

nmaOutcomeDocShape = require('lib/db_docs/doc_shapes/nma_outcome_doc_shape');

NMA_OUTCOME_PREFIX = require('lib/doc_prefixes').nmaOutcome;

convertListToOrderedMap = require('lib/immutable_utils').convertListToOrderedMap;

_ref = require('lib/nma_helper'), nmaOutcomeDataToGdtData = _ref.nmaOutcomeDataToGdtData, gdtOutcomeDataToNmaOutcomeData = _ref.gdtOutcomeDataToNmaOutcomeData, gdtOutcomeTypeToNmaVizOutcomeType = _ref.gdtOutcomeTypeToNmaVizOutcomeType;

autoCalculateEffectClassification = NmaComponents.autoCalculateEffectClassification, autoCalculateEffectInterpretation = NmaComponents.autoCalculateEffectInterpretation;

module.exports = DbDoc(nmaOutcomeDocShape, {
  dbSetup: {
    idPrefix: NMA_OUTCOME_PREFIX
  },
  methods: {
    updateDescription: function(description) {
      return this.setAt('description')(description);
    },
    updateOutcomeData: function(interventionId, comparatorId, outcomeData) {
      return this.updateAt('data')(function(currentData) {
        var comparisonIdx, gdtData;
        if (currentData == null) {
          currentData = [];
        }
        gdtData = nmaOutcomeDataToGdtData(outcomeData, interventionId, comparatorId);
        comparisonIdx = _.findIndex(currentData, function(dataEntry) {
          return dataEntry.interventionId === interventionId && dataEntry.comparatorId === comparatorId;
        });
        if (comparisonIdx < 0) {
          comparisonIdx = _.findIndex(currentData, function(dataEntry) {
            return dataEntry.interventionId === comparatorId && dataEntry.comparatorId === interventionId;
          });
        }
        if (comparisonIdx < 0) {
          return _.union(currentData, [gdtData]);
        } else {
          if (interventionId !== currentData[comparisonIdx].interventionId) {
            gdtData.interventionId = comparatorId;
            gdtData.comparatorId = interventionId;
          }
          currentData[comparisonIdx] = gdtData;
          return currentData;
        }
      });
    },
    overwriteComparisonsEffectMeasure: function(effectMeasure, effectMeasureOther) {
      var applyToEstimate;
      applyToEstimate = function(estimate) {
        if (!estimate) {
          return estimate;
        }
        estimate.effectMeasure = effectMeasure;
        if (effectMeasure === 'Other') {
          estimate.effectMeasureOther = effectMeasureOther;
        } else {
          delete estimate.effectMeasureOther;
        }
        return estimate;
      };
      return this.updateAt('data')(function(currentData) {
        if (!currentData) {
          return currentData;
        }
        return _.map(currentData, function(dataEntry) {
          dataEntry.nmaEffect = applyToEstimate(dataEntry.nmaEffect);
          dataEntry.directEffect = applyToEstimate(dataEntry.directEffect);
          dataEntry.indirectEffect = applyToEstimate(dataEntry.indirectEffect);
          return dataEntry;
        });
      });
    },
    deleteExplanation: function(explanationId) {
      return this.updateAt('data')(function(currentData) {
        if (!currentData) {
          return;
        }
        return _.map(currentData, function(dataEntry) {
          var newExplanationsMap;
          if (!dataEntry.explanations) {
            return dataEntry;
          }
          newExplanationsMap = _.mapObject(dataEntry.explanations || {}, function(explanationsArr, key) {
            return _.without(explanationsArr, explanationId);
          });
          dataEntry.explanations = newExplanationsMap;
          return dataEntry;
        });
      });
    },
    autoCalculateEffectClassification: function(options) {
      var clear, higherIsBetter, outcome, outcomeId, question, thresholdType, thresholds;
      question = options.question, clear = options.clear;
      thresholdType = question.get('thresholdOptions');
      thresholds = {
        T1: this.getAt('T1'),
        T2: this.getAt('T2'),
        T3: this.getAt('T3')
      };
      outcomeId = this.getAt('_id');
      higherIsBetter = this.getAt('higherIsBetter');
      outcome = _.extend(_.omit(this.json(), 'data'), {
        type: gdtOutcomeTypeToNmaVizOutcomeType(this.getAt('type'))
      });
      return this.updateAt('data')(function(currentData) {
        return _.map(currentData, function(data) {
          var effectClassification, outcomeData;
          outcomeData = gdtOutcomeDataToNmaOutcomeData(data, outcomeId);
          effectClassification = clear ? void 0 : autoCalculateEffectClassification(outcome, outcomeData, thresholdType, question.get('denominator', NmaComponents.STANDARD_DENOMINATOR));
          data.effectClassification = effectClassification;
          return data;
        });
      });
    },
    autoCalculateEffectInterpretation: function(options) {
      var clear, interventions, outcome, outcomeId, outcomeName, question;
      clear = options.clear, question = options.question;
      outcomeId = this.getAt('_id');
      outcomeName = this.getAt('name');
      interventions = convertListToOrderedMap(question.get('interventions', Immutable.List()));
      outcome = _.extend(_.omit(this.json(), 'data'), {
        type: gdtOutcomeTypeToNmaVizOutcomeType(this.getAt('type'))
      });
      return this.updateAt('data')(function(currentData) {
        return _.map(currentData, function(data) {
          var comparator, interpretation, intervention, outcomeData, reverseInterpretation, _ref1;
          intervention = interventions.get(data.interventionId, Immutable.Map());
          comparator = interventions.get(data.comparatorId, Immutable.Map());
          outcomeData = gdtOutcomeDataToNmaOutcomeData(data, outcomeId);
          _ref1 = clear ? {
            interpretation: {
              label: void 0
            },
            reverseInterpretation: {
              label: void 0
            }
          } : autoCalculateEffectInterpretation($.t, outcome, outcomeData, intervention.get('name'), comparator.get('name')), interpretation = _ref1.interpretation, reverseInterpretation = _ref1.reverseInterpretation;
          return _.extend(data, {
            interpretation: (interpretation != null ? interpretation.label : void 0) || '',
            reverseInterpretation: (reverseInterpretation != null ? reverseInterpretation.label : void 0) || ''
          });
        });
      });
    }
  }
});
